/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Sensor_PhInputs */

const vi_irrigation_sensor_ph = /** @type {(inputs: Irrigation_Sensor_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pH`)
};

/**

* @param {Irrigation_Sensor_PhInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_sensor_ph = /** @type {((inputs?: Irrigation_Sensor_PhInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Sensor_PhInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_sensor_ph(inputs)
});